import cn from 'clsx'
import { intervalToDuration } from 'date-fns'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { Trade } from '@App/redux/slices/trade/trades/types'

import { useTrades } from '../../../../model'
import { Card } from '../Card'

import s from './styles.module.scss'

const formatDurationDF = (start: Date, end: Date) => {
  const {
    days = 0,
    hours = 0,
    minutes = 0,
  } = intervalToDuration({
    start,
    end,
  })

  if (days > 0) return `${days}d ${hours}h ${minutes}m`
  if (hours > 0) return `${hours}h ${minutes}m`
  return `${minutes}m`
}
const averageHoldingTimeDF = (trades: any[]) => {
  if (trades.length === 0) return '-'

  const durations = trades.map((t) => {
    const start = new Date(t.open_time)
    const end = new Date(t.close_time)
    return end.getTime() - start.getTime()
  })

  const avgMs = durations.reduce((sum, v) => sum + v, 0) / durations.length

  return formatDurationDF(0 as any, avgMs as any)
}

export const AverageHoldingTime = () => {
  const { trades } = useTrades()
  const closedTrades = trades.filter((v) => v.status === 'closed')
  const profitableTrades = closedTrades.filter((v) => v.result > 0)
  const lossTrades = closedTrades.filter((v) => v.result < 0)
  const avgProfitable = averageHoldingTimeDF(profitableTrades)
  const avgLoss = averageHoldingTimeDF(lossTrades)
  const avgCombined = averageHoldingTimeDF(closedTrades)

  return (
    <Card className={s.container} title="Average holding time" contentClassName={s.content}>
      <div className={s.row}>
        <div className={s.title}>Profitable</div>
        <div className={s.value}>{avgProfitable}</div>
      </div>
      <div className={s.row}>
        <div className={s.title}>Loss making</div>
        <div className={s.value}>{avgLoss}</div>
      </div>
      <div className={s.row}>
        <div className={s.title}>Combined</div>
        <div className={s.value}>{avgCombined}</div>
      </div>
    </Card>
  )
}
export const AverageReturn = () => {
  const { trades } = useTrades()

  const closedTrades = trades.filter((v) => v.status === 'closed')
  const profitableTrades = closedTrades.filter((v) => v.result > 0)
  const lossTrades = closedTrades.filter((v) => v.result < 0)

  const averageReturn = (trades: Trade[]) => {
    if (trades.length === 0) return 0

    const sum = trades.reduce((acc, t) => acc + t.result, 0)
    return sum / trades.length
  }

  const avgProfitable = averageReturn(profitableTrades)
  const avgLoss = averageReturn(lossTrades)
  const avgCombined = averageReturn(closedTrades)

  return (
    <Card className={s.container} title="Average return" contentClassName={s.content}>
      <div className={s.row}>
        <div className={s.title}>Profitable</div>
        <div className={cn(s.value, avgProfitable > 0 && s.positive)}>
          {avgProfitable ? getValueWithCurrency('EUR', avgProfitable) : '-'}
        </div>
      </div>
      <div className={s.row}>
        <div className={s.title}>Loss making</div>
        <div className={cn(s.value, avgLoss < 0 && s.negative)}>
          {avgLoss ? getValueWithCurrency('EUR', avgLoss) : '-'}
        </div>
      </div>
      <div className={s.row}>
        <div className={s.title}>Combined</div>
        <div className={cn(s.value, avgCombined < 0 ? s.negative : s.positive)}>
          {avgCombined ? getValueWithCurrency('EUR', avgCombined) : '-'}
        </div>
      </div>
    </Card>
  )
}
